/**
 * @file debuggerStore.js
 * @description Lightweight pub/sub event store for the auto-debugger.
 *              Zero external dependencies. Dev-only — tree-shaken in production.
 */

const MAX_LOGS = 200; // cap memory usage

const EVENT_TYPES = {
    ERROR: 'error',
    WARNING: 'warning',
    NETWORK: 'network',
    PERF: 'perf',
    REACT: 'react',
    CONSOLE: 'console',
    ROUTE: 'route',
};

let _logs = [];
let _listeners = new Set();
let _idCounter = 0;

// ─── Public API ───────────────────────────────────────────────────────────────

function push(type, payload) {
    const entry = {
        id: ++_idCounter,
        type,
        ts: Date.now(),
        ...payload,
    };

    _logs = [entry, ..._logs].slice(0, MAX_LOGS);
    _listeners.forEach((fn) => fn([..._logs]));
    return entry;
}

function subscribe(fn) {
    _listeners.add(fn);
    fn([..._logs]); // send current state immediately
    return () => _listeners.delete(fn);
}

function clear() {
    _logs = [];
    _listeners.forEach((fn) => fn([]));
}

function getLogs() {
    return [..._logs];
}

export { push, subscribe, clear, getLogs, EVENT_TYPES };
